/*
 * Post-donation.ts
 * Description: Includes the declaration
 * of the function for submitting donations
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Create a donation request
 *
 * @return {Object} Promise - whether the action was successful
 * @param {String} slug - id of the restaurant
 */
export function postDonation(slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'restaurants/' + slug + '/donations',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
